import React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import IconWrapper from "../../../components/icon-wrapper/IconWrapper";
import ImageOverlayCard from "../../../components/image-overlay-card/ImageOverlayCard";

export default function AllServiceDisease({
  img,
  title,
  text,
  list,
  reverse = false,
}) {
  const { t } = useTranslation();

  return (
    <StyledAllServiceDisease $reverse={reverse}>
      <div className="container">
        <div className="all-service-disease__wrap">
          <div className="all-service-disease__left">
            <h1>{t(title)}</h1>
            <p>{t(text)}</p>
            <ul>
              {list.map((i) => (
                <li key={i}>
                  <IconWrapper
                    w={20}
                    h={20}
                    iconW={14}
                    iconH={14}
                    icon="check"
                  />
                  <p>{t(i)}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className="all-service-disease__right">
            <h1>{t(title)}</h1>
            <p>{t(text)}</p>
            <ul>
              {list.map((i) => (
                <li key={i}>
                  <IconWrapper
                    w={18}
                    h={18}
                    iconW={12}
                    iconH={12}
                    icon="check"
                  />
                  <p>{t(i)}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <ImageOverlayCard
        className="all-service-disease__img"
        image={img}
        title={t(title)}
        alt={t(title)}
      />
    </StyledAllServiceDisease>
  );
}

const StyledAllServiceDisease = styled.section`
  background-color: var(--white);
  padding: 140px 0;
  position: relative;

  .all-service-disease {
    &__wrap {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &__left,
    &__right {
      h1 {
        color: var(--title);
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        margin-bottom: 24px;
      }

      & > p {
        color: var(--text);
        font-size: var(--fs-body);
        font-style: normal;
        font-weight: var(--fw-regular);
        line-height: var(--lh-body);
        text-align: left;
        margin-bottom: 32px;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 24px;

        li {
          display: flex;
          align-items: center;
          gap: 12px;

          p {
            color: var(--title);
            font-size: var(--fs-body-sm);
            font-style: normal;
            font-weight: var(--fw-medium);
            line-height: var(--lh-body);
          }
        }
      }
    }

    &__left {
      padding-right: 100px;
    }

    &__right {
      padding-left: 100px;
    }

    &__img {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 100%;
    }

    ${({ $reverse }) =>
      $reverse &&
      css`
        &__img {
          right: auto;
          left: 0;
        }
      `}
  }
`;
